import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=d329b396&scoped=true"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"
import style0 from "./empty.vue?vue&type=style&index=0&id=d329b396&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d329b396",
  null
  
)

export default component.exports